import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Mail, Twitter, Github } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-gray-800 bg-gray-900/50 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <BookOpen className="w-6 h-6 text-emerald-500" />
              <div>
                <div className="text-lg font-bold text-white">Options Analogies</div>
                <div className="text-xs text-gray-400">by Datatomic Labs</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              See options differently. Clear, calm, evidence-minded education for retail investors.
            </p>
            <div className="flex space-x-3">
              <a href="mailto:contact@datatomiclabs.com" className="text-gray-400 hover:text-emerald-500 transition">
                <Mail className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-500 transition">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-500 transition">
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Learn */}
          <div>
            <h3 className="text-white font-semibold mb-4">Learn</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/csp" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Cash-Secured Puts
                </Link>
              </li>
              <li>
                <Link to="/covered-calls" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Covered Calls
                </Link>
              </li>
              <li>
                <Link to="/wheel" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  The Wheel Strategy
                </Link>
              </li>
              <li>
                <Link to="/glossary" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Glossary
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/analogies" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Analogies Library
                </Link>
              </li>
              <li>
                <Link to="/math-risk" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Math & Risk
                </Link>
              </li>
              <li>
                <Link to="/teaching-kits" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Teaching Kits
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/disclaimers" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Disclaimers
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  About
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-emerald-500 transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Datatomic Labs. All rights reserved.
            </p>
            <p className="text-xs text-gray-500 text-center md:text-right max-w-md">
              Education only. Not financial, investment, tax, or legal advice. Options involve risk of loss.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;